class CroProductPopup extends HTMLElement {
  constructor() {
    super();

    this.delayMs = Number(this.dataset.delay || 14000);
    this.scrollDepth = Number(this.dataset.scrollDepth || 30);
    this.sessionKey = this.dataset.sessionKey || "cro_product_popup_shown";
    this.newsletterSessionKey = this.dataset.newsletterSessionKey || "newsletter_popup_shown";
    this.dismissCookie = this.dataset.dismissCookie || "cro_product_popup_dismissed";
    this.dismissDays = Number(this.dataset.dismissDays || 6);

    this.opened = false;
    this.timerStarted = false;
  }

  connectedCallback() {
    this.popup = this.querySelector(".cro-popup");
    this.closeButton = this.querySelector(".cro-popup__close");
    this.overlay = this.querySelector("modal-overlay");

    if (!this.popup) {
      console.error("CRO popup not found");
      return;
    }

    if (this.shouldSuppress()) return;

    this.startTimer();
    this.bindScrollTrigger();
    this.bindClose();
  }

  shouldSuppress() {
    return (
      this.getSession(this.sessionKey) === "1" ||
      this.getCookie(this.dismissCookie) !== null
    );
  }

 startTimer() {

  if (this.timerStarted) return;

  this.timerStarted = true;

  window.setTimeout(() => {

    this.popup = this.querySelector(".cro-popup");

    this.overlay = this.querySelector("modal-overlay");

    if (!this.popup) {

      console.error("CRO popup not found before opening");

      return;

    }

    this.open();

  }, this.delayMs);

}

  bindScrollTrigger() {
    window.addEventListener(
      "scroll",
      () => {
        if (this.opened || this.shouldSuppress()) return;

        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const docHeight = document.documentElement.scrollHeight - window.innerHeight;

        if (docHeight <= 0) return;

        const currentDepth = (scrollTop / docHeight) * 100;

        if (currentDepth >= this.scrollDepth) {
          this.open();
        }
      },
      { passive: true }
    );
  }

  bindClose() {
    this.closeButton?.addEventListener("click", () => this.close(true));
    this.overlay?.addEventListener("click", () => this.close(true));

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && this.opened) {
        this.close(true);
      }
    });
  }

open() {
  this.popup = this.querySelector(".cro-popup");
  this.overlay = this.querySelector("modal-overlay");

  if (!this.popup) return;
  if (this.opened) return;
  if (this.shouldSuppress()) return;

  this.opened = true;

  this.setSession(this.sessionKey, "1");
  this.setSession(this.newsletterSessionKey, "1");

  this.popup.classList.add("active");
  this.popup.classList.remove("invisible", "content-hidden");

  this.overlay?.classList.remove("invisible");

  document.documentElement.classList.add("open-modal");
  document.body.setAttribute("data-scroll-locked", "true");
}

  close(withCooldown) {
    this.popup.classList.remove("active");
    this.popup.classList.add("invisible");

    this.overlay?.classList.add("invisible");

    document.documentElement.classList.remove("open-modal");
    document.body.removeAttribute("data-scroll-locked");

    if (withCooldown) {
      this.setCookie(this.dismissCookie, "1", this.dismissDays);
    }
  }

  getSession(key) {
    try {
      return sessionStorage.getItem(key);
    } catch {
      return null;
    }
  }

  setSession(key, value) {
    try {
      sessionStorage.setItem(key, value);
    } catch {
      // ignore
    }
  }

  getCookie(name) {
    const parts = `; ${document.cookie}`.split(`; ${name}=`);
    if (parts.length === 2) {
      return parts.pop().split(";").shift();
    }
    return null;
  }

  setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${value}; expires=${expires}; path=/`;
  }
}


document.querySelectorAll("cro-product-popup").forEach((popup) => {
  if (!popup.timerStarted) {
    popup.connectedCallback();
  }
});

if (!customElements.get("cro-product-popup")) {

  customElements.define("cro-product-popup", CroProductPopup);

}

window.addEventListener("load", () => {

  document.querySelectorAll("cro-product-popup").forEach((popup) => {

    popup.connectedCallback();

  });

});